import React from "react";
import {Chip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {deliveryProgress} from "./delivery-progress";

export default function DeliveryProgressChip({status}) {
    const {t} = useTranslation();
    const progress = deliveryProgress(status);
    return <Chip size="small" variant="outlined" color={progress.color} label={t(progress.label)}/>;
}
